import React from "react"
import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import withLocation from "../components/with-location"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Header from "../components/header"
import Footer from "../components/footer"
import { useSubNavigation } from "../components/use-sub-navigation"

import LearnFeatures from "../components/learn/features"
import LearnAbouthosokawaryu from "../components/learn/abouthosokawaryu"
import LearnClasses from "../components/learn/classes"

import useMixins from "../components/css-functions"
import { ln2Blank } from "../components/util-functions"

const Learn = ({
  search,
  location,
}) => {
  const navItems = [
    { 
      label: 'features',
      name: '教室の\n特徴',
    },
    { 
      label: 'abouthosokawaryu',
      name: '細川流\nのこと',
    },
    { 
      label: 'classes',
      name: '全国の\n教室一覧',
    },
  ]

  const pagePath = location.pathname
  const { t } = search

  const subNavigation = useSubNavigation(navItems, pagePath, t)

  const mixins = useMixins()

  const bp = useBreakpoint()
  const bgWidth = bp.isTablet ? bp.isPcLarge ? '1800px' : 'calc( 100vw * 1.4 )' : '800px' 
  const posOffsetX = bp.isTablet ? 140 : 20 

  const pageTitle = "教室のご案内"

  const style = {
    mainContent: css`
      ${mixins.default.mainContentStyle}
    `,
    pcTitle: css`
      ${ mixins.default.simpleTitleStyle }
    `,
  }

  const PCTitle = (tabIndex) => bp.isTablet ? <h2 css={ style.pcTitle }>{ ln2Blank(navItems[tabIndex].name) }</h2> : null

  const TabbedContent = () => {
    switch (t) {
      case navItems[0].label:
        return <LearnFeatures pcTitle={ PCTitle(0) } />
      case navItems[1].label:
        return <LearnAbouthosokawaryu pcTitle={ PCTitle(1) } />
      case navItems[2].label:
        return <LearnClasses pcTitle={ PCTitle(2) } />
      default:
        return <LearnFeatures pcTitle={ PCTitle(0) } />
    }
  }

  return (
    <Layout>
      <SEO title={pageTitle} />
      <Header
        title={pageTitle}
        bgData={{
          image: 'bgFuji.png',
          width: bgWidth,
          posOffset: {
            x: posOffsetX,
            y: 20,
          }
        }}
        subNavigation={ subNavigation }
      />
      <div css={style.mainContent}>
        <TabbedContent />
      </div>
      <Footer />
    </Layout>
  )
}

export default withLocation(Learn)